import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class FooterReveal {
    constructor(element) {
        this.footer = element;
        this._resizeObserver = null;
        this.scrollTrigger = null;
        this.init();
    }

    init() {
        this.setup();

        window.addEventListener("resize", () => this.refresh());

        // Watch the element directly above the footer (or document.body as fallback)
        // so any content addition/removal that changes page height triggers a refresh
        const watched = this.footer.previousElementSibling ?? document.body;
        this._resizeObserver = new ResizeObserver(() => this.refresh());
        this._resizeObserver.observe(watched);
    }

    refresh() {
        if (this.scrollTrigger) {
            this.scrollTrigger.kill();
            this.scrollTrigger = null;
        }
        gsap.set(this.footer, { clearProps: "marginTop" });
        this.setup();
    }

    setup() {
        if (window.innerWidth < 1024) return;

        const height = this.footer.offsetHeight;

        gsap.set(this.footer, {
            marginTop: -height,
        });

        this.scrollTrigger = ScrollTrigger.create({
            trigger: this.footer,
            pin: true,
            start: "bottom bottom",
            end: `+=${height}`,
        });
    }

    destroy() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
        }
        if (this.scrollTrigger) {
            this.scrollTrigger.kill();
            this.scrollTrigger = null;
        }
        gsap.set(this.footer, { clearProps: "marginTop" });
    }
}